import moment from 'moment-timezone';
import config from '../../config';
import { fetchM } from './fetchM';
import { handleError } from './error';
import {
  HIMS_POSTCODES_REQUEST,
  HIMS_POSTCODES_SUCCESS,
  HIMS_POSTCODES_FAILURE,
} from '../constants/actions';

function himsPostcodesRequest() {
  return {
    type: HIMS_POSTCODES_REQUEST,
  };
}

function himsPostcodesSuccess(data, token = null) {
  return {
    type: HIMS_POSTCODES_SUCCESS,
    payload: {
      data,
      token,
    },
  };
}

function himsPostcodesError(message) {
  return {
    type: HIMS_POSTCODES_FAILURE,
    payload: {
      statusText: message,
    },
  };
}

export function fetchHimsPostcodes(fresh = true) {
  return (dispatch) => {
    let token = null;
    let reload = false;
    let himsPostcodesData = {};
    dispatch(himsPostcodesRequest());
    if (!fresh) {
      try {
        himsPostcodesData = JSON.parse(localStorage.getItem(`${config.get('appName')}.himsPostcodes`)) || {};
      } catch (e) {
        Bugsnag.notifyException(e);
      }
      if (
        !himsPostcodesData.data ||
        config.get('version') !== himsPostcodesData.version ||
        moment().isAfter(moment(himsPostcodesData.createdAt).add(1, 'day'))
      ) {
        reload = true;
      }
      if (!reload) {
        dispatch(himsPostcodesSuccess(himsPostcodesData.data));
        return Promise.resolve();
      }
    }
    return dispatch(fetchM('/hims/postcodes/', {
      credentials: 'include',
    }))
      .then((res) => {
        token = res.headers.get('X-Csrf-Token');
        return res.json();
      })
      .then((data) => {
        try {
          localStorage.setItem(`${config.get('appName')}.himsPostcodes`, JSON.stringify({
            data,
            createdAt: moment().toDate(),
            version: config.get('version'),
          }));
        } catch (e) {
          Bugsnag.notifyException(e);
        }
        dispatch(himsPostcodesSuccess(data, token));
      })
      .catch((err) => {
        // reuse data from localStorage in case of error
        if (himsPostcodesData.data) {
          dispatch(himsPostcodesSuccess(himsPostcodesData.data));
          return Promise.resolve();
        }
        dispatch(handleError(err, himsPostcodesError));
        return Promise.reject(err);
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/himsPostcodes.js